<template>
  <a href="https://wezift.com/parent-portal/app-advisor/"
    target="_blankManageRequestsHeaderIcon"
    class="icon-advisor"
    @click="openAppAdvisor">
  <icon-app-advisor width="48"
                    height="48"
                    iconColor="#fff" />
  </a>
</template>

<script>
  import analytics from '@/services/analytics.js'

  export default {
    methods: {
      openAppAdvisor() {
        analytics.sendEvent('Pk_AppAdvr')
      }
    }
  }
</script>